/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Microsoft_Tenant_Set_DescInputs */



/**
* | output |
* | --- |
* | "Microsoft sign-in was restricted to one Microsoft Entra tenant, or the tenant was changed." |
*
* @param {Audit_Details_Microsoft_Tenant_Set_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_microsoft_tenant_set_desc = /** @type {((inputs?: Audit_Details_Microsoft_Tenant_Set_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Microsoft_Tenant_Set_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Microsoft-Anmeldung wurde auf einen Microsoft-Entra-Mandanten beschränkt, oder der Mandant wurde geändert.")
	return /** @type {LocalizedString} */ ("Microsoft sign-in was restricted to one Microsoft Entra tenant, or the tenant was changed.")
});